import { render, staticRenderFns } from "./OrdererInfo.vue?vue&type=template&id=60407f3b&scoped=true&"
import script from "./OrdererInfo.vue?vue&type=script&lang=js&"
export * from "./OrdererInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrdererInfo.vue?vue&type=style&index=0&id=60407f3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60407f3b",
  null
  
)

export default component.exports